/* Per-achievement badge textures (albedo + tangent-space normal map). The 3D
 * BadgeViewer renders these as a metallic PBR material. Achievements without
 * dedicated art yet fall back to the Sakhal placeholder coin — add a key here
 * when you drop new <name>_color.png + <name>_normal.png into public/achievements/. */
const FALLBACK = { color: '/achievements/sakhal_color.png', normal: '/achievements/sakhal_normal.png' }

// 1250² WebP (sharper + far smaller than the old PNGs). Normals exported lossless.
const ART: Record<string, { color: string; normal: string }> = {
  rate_first: { color: '/achievements/rate_first_color.webp', normal: '/achievements/rate_first_normal.webp' },
  rate_three: { color: '/achievements/rate_three_color.webp', normal: '/achievements/rate_three_normal.webp' },
  invite_5: { color: '/achievements/invite_5_color.webp', normal: '/achievements/invite_5_normal.webp' },
  invite_10: { color: '/achievements/invite_10_color.webp', normal: '/achievements/invite_10_normal.webp' },
}

export function badgeArt(asset: string): { color: string; normal: string } {
  return ART[asset] ?? FALLBACK
}
